module.exports = __webpack_public_path__ + "static/img/four_08.9bf9444.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/modules/AtomicChain/assets/personalIntroduction/four_08.jpg
// module id = 6JKj
// module chunks = 3